import React, { useState, useEffect, useRef } from 'react';

const Typewriter = ({ text, speed = 40, delay = 0, className = "", as: Component = "span", glow = false }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
          setTimeout(() => setIsTyping(true), delay);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [delay, hasStarted]);

  useEffect(() => {
    if (!isTyping) return;

    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex <= text.length) {
        setDisplayedText(text.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [isTyping, text, speed]);

  return (
    <Component 
      ref={elementRef} 
      className={`inline-block min-h-[0.8em] ${className} ${glow ? 'text-glow' : ''} ${isTyping ? 'typewriter-cursor' : ''}`}
      style={{ whiteSpace: 'pre-wrap' }}
    >
      {displayedText}
    </Component>
  );
};

export default Typewriter;